import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import Header from '../../../../../../components/Stake/header';
import DotIcon from '../../../../../../assets/images/tokens/dot.svg';
import { DOT } from '../../../../../../constants/blockchain-constants';
import stylesParent from '../../styles/frame/frame.module.scss';
import stylesConnect from '../../styles/connect/connect.module.scss';
import Loader from '../../../../../../components/loader';

const Loading = ({ message }) => {
  const dark = useSelector((state) => state.basic.dark);

  return (
    <>
      <Header icon={DotIcon} title={`${DOT}-Nomination`} />
      <div className={stylesConnect.delegateContainer}>
        <div
          className={cn(
            stylesParent.cardFooterControls,
            stylesParent.withBackground,
            stylesParent.lg,
            {
              [stylesParent.dark]: dark,
            },
          )}
        >
          <div style={{ margin: '100px 0' }}>
            <Loader />
          </div>
          <Button
            disabled
            variant='contained'
            color='secondary'
            className={stylesParent.cardFooterControlsButton}
          >
            {message}
          </Button>
        </div>
      </div>
    </>
  );
};

Loading.propTypes = {
  message: PropTypes.string.isRequired,
};

export default Loading;
